import {DetailsRow, IDetailsRowProps, mergeStyleSets} from '@fluentui/react';
import {EntityListColumn} from 'components';
import {renderTransferStatus} from 'components/EntityList/ColumnRenderers';
import {getArrayFieldColumn, getDateColumn, getTextColumn} from 'helpers';
import React from 'react';
import {useTranslation} from 'react-i18next';
import {TransferStatus} from 'types';

export const useVehicleProjectListColumns = (): EntityListColumn[] => {
	const {t} = useTranslation('features/vehicleprojects');
	const columns: EntityListColumn[] = React.useMemo(
		() =>
			[
				getTextColumn(
					'generation',
					t('ModelSeries'),
					'generation',
					false,
					true,
				),
				getArrayFieldColumn('derivates', t('Derivate'), 'derivates', false),
				{
					key: 'source',
					name: t('Source'),
					fieldName: 'source',
					minWidth: 70,
					maxWidth: 90,
					isResizable: true,
					filterable: true,
					onRender: (item: any) =>
						item.isManuallyCreated ? t('SourceManual') : t('SourceLPM'),
				},
				{
					key: 'requirementsFinal',
					name: t('FinalRequirementsCount'),
					fieldName: 'requirementsFinal',
					minWidth: 70,
					maxWidth: 100,
					isResizable: true,
					filterable: false,
					sortable: false,
					onRender: (item: any) =>
						item.requirementCounts?.final ?? item.requirementsCount ?? 0,
				},
				{
					key: 'requirementsInterim',
					name: t('InterimRequirementsCount'),
					fieldName: 'requirementsInterim',
					minWidth: 70,
					maxWidth: 100,
					isResizable: true,
					filterable: false,
					sortable: false,
					onRender: (item: any) =>
						item.requirementCounts?.interim ??
						item.interimRequirementsCount ??
						0,
				},
				getDateColumn('sopVsi', t('EarliestSOP'), 'sopVsi', true, false),
				getDateColumn('eopVsi', t('LatestEOP'), 'eopVsi', true, false),
				getDateColumn(
					'lastTransfer',
					t('LastTransfer'),
					'lastTransfer',
					true,
					false,
				),
				{
					key: 'transferStatus',
					name: t('TransferStatus'),
					fieldName: 'transferStatus',
					minWidth: 150,
					isResizable: true,
					sortable: true,
					filterable: true,
					onRender: renderTransferStatus(),
				},
			] as EntityListColumn[],
		[t],
	);
	return columns;
};

export function vehicleProjectRowRenderer(props?: IDetailsRowProps) {
	if (!props) return null;
	const {item} = props;
	const transferNotSet = item.transferStatus === TransferStatus.TransferNotSet;
	const changesAvailableToTransfer =
		item.transferStatus === TransferStatus.ChangesAvailableToTransfer;

	const className = [
		props.className,
		transferNotSet && vehicleProjectRowClasses.rowNotTransferred,
		changesAvailableToTransfer && vehicleProjectRowClasses.rowChangesAvailable,
	]
		.filter(Boolean)
		.join(' ');

	return <DetailsRow {...props} className={className} />;
}

const vehicleProjectRowClasses = mergeStyleSets({
	rowNotTransferred: {
		background: '#fde7e9',
	},
	rowChangesAvailable: {
		background: '#F8CD02',
	},
});
